define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/documentElement.js
// module id = 62
// module chunks = 0